module.exports = __webpack_public_path__ + "static/media/woo4.2dc08498.png";